import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import omit from 'lodash/omit'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import mapValues from 'lodash/mapValues';
import { defaultProps } from '../../components/type/api';
import TypeImpl from '../../components/type/TypeImpl';
import platformDefaults from './defaults'; // TODO: Fixme
// eslint-disable-next-line react/forbid-foreign-prop-types

var contextPropTypes = omit(TypeImpl.propTypes, 'children');

var context = _objectSpread(_objectSpread(_objectSpread({}, mapValues(contextPropTypes, function () {
  return undefined;
})), defaultProps), {}, {
  // all top-level `<Type />` is block
  inline: false
}, platformDefaults); // create a context for enabling correct inheritance of props for nested <Type />


var TypographyContext = /*#__PURE__*/React.createContext(context); // TypographyContextProvider takes the same props as `<Type />`,
// and it merges those props with the existing context value
//
// ex: `<TypographyContextProvider size={3} italic chronicle />`

var TypographyContextProvider = function TypographyContextProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var typographyContext = useContext(TypographyContext);
  return /*#__PURE__*/React.createElement(TypographyContext.Provider, {
    // merge new props into context for child <Type /> nodes
    value: _objectSpread(_objectSpread({}, mapValues(typographyContext, function (val, key) {
      // gotham and chronicle are mutually exclusive. Values in props must override values in context.
      // Without unsetting the other font type, a nested <Type/> will receive both props, which
      // is undefined behavior and has the effect of rendering chronicle. This also must be done in <Type/> Component
      // See https://github.com/NerdWallet/structured-content/pull/298
      if (key === 'gotham' && val && props.chronicle) return false;
      if (key === 'chronicle' && val && props.gotham) return false;
      return val;
    })), props)
  }, children);
};

TypographyContextProvider.propTypes = TypeImpl.propTypes;
TypographyContextProvider.defaultProps = {};
export { TypographyContextProvider };
export default TypographyContext;